import { FC, useEffect, useState, useCallback } from 'react';
import { Formik, Form } from 'formik';
import { Link } from 'react-router-dom';

import {
  ConnectWallet,
  useAddress,
  useLogin,
  useSDK,
} from '@thirdweb-dev/react';
import { ConnectButton } from '@rainbow-me/rainbowkit';
import {
  ConnectKitProvider,
  ConnectKitButton,
  getDefaultClient,
} from 'connectkit';
import {
  useAccount,
  useSigner,
  useDisconnect,
  useNetwork,
  useSwitchNetwork,
} from 'wagmi';

import { ReactComponent as Logo } from 'assets/images/logo.svg';
import { ReactComponent as UserProfile } from 'assets/icons/user-profile.svg';
import { ReactComponent as Menu } from 'assets/icons/hamburger.svg';
import { ReactComponent as Search } from 'assets/icons/search.svg';
import { ReactComponent as Close } from 'assets/icons/close.svg';
import { ReactComponent as AngleRight } from 'assets/icons/angle-right.svg';

import authService from 'services/authService';
import { getSession, storage } from 'utils';
import Input from '../Input';
import Button from '../Button';
import { useToast } from '../Toast/ToastProvider';

const Header: FC = () => {
  const [open, setOpen] = useState(false);

  const { address } = useAccount();
  const { chain, chains } = useNetwork();

  // const address = useAddress();
  const sdk = useSDK();
  const { data: signer } = useSigner();
  const [isUserSignedIn, setIsUserSignedIn] = useState(false);
  const [loginBtnStatus, setLoginBtnStatus] = useState(false);

  const logout = async () => {
    try {
      await authService.logout();
    } catch (error) {
      console.log(error);
    }
  };

  const disconnect = useDisconnect({
    onSuccess(data) {
      logout();
      console.log('Success', data);
    },
  });
  const toast = useToast();
  const login = async () => {
    // Add the domain of the application users will login to, this will be used throughout the login process
    const domain = 'septagon.io';
    // Generate a signed login payload for the connected wallet to authenticate with
    const loginPayload = await sdk?.auth.login(domain);

    // console.log(loginPayload);
    // loginPayload!.payload.chain_id = 80001 as number;
    try {
      await authService.login(loginPayload);
      setIsUserSignedIn(true);
    } catch (error: any) {
      console.log(error);
    }

    setIsUserSignedIn(true);
  };

  const { error, isLoading, pendingChainId, switchNetwork } =
    useSwitchNetwork();

  useEffect(() => {
    if (address && chain?.id !== 80001) {
      switchNetwork?.(80001);
      toast?.error('Please connect your to Polygon mumbau');
    } else {
      // logout();
      // console.log('logging out...');
    }
  }, [address]);

  return (
    <>
      <div className="hidden items-center bg-black lg:flex">
        <div className="container mx-auto">
          <div className="flex p-4 items-center justify-between">
            <div className="flex gap-8 items-center">
              <Link
                to="/"
                className="inline-flex flex-none items-center justify-center"
              >
                <Logo />
              </Link>
              <Formik
                initialValues={{ searchParams: '' }}
                onSubmit={() => setOpen(false)}
              >
                <Form>
                  <Input
                    className="bg-transparent border border-primary-2 outline-0 py-1 rounded-2xl text-white xl:min-w-[300px] xl:min-w-[456px] px-4"
                    placeholder="Search lands, apartments and buildings"
                  />
                </Form>
              </Formik>
            </div>
            <div className="flex gap-8 items-center">
              {/* <Link to="/about" className="text-white">
                About us
              </Link>
              <Link to="/faqs" className="text-white">
                FAQs
              </Link> */}
              <Link to="/profile/edit" className="text-white">
                <span className="inline-flex flex-none items-center justify-center">
                  <UserProfile />
                </span>
              </Link>{' '}
              {/* {address && (
                <Button type="button" onClick={login} variant="primary">
                  Connect Wallet
                </Button>
              )} */}
              <ConnectKitButton.Custom>
                {({
                  isConnected,
                  isConnecting,
                  show,
                  hide,
                  truncatedAddress,
                }) => (
                  <Button
                    type="button"
                    onClick={() => {
                      console.log(getSession(storage.getToken()), 'token');

                      if (address && !getSession(storage.getToken())) {
                        login();
                      } else {
                        show?.();
                      }
                    }}
                    variant="primary"
                    className="bg-primary-2"
                  >
                    {isConnected
                      ? !getSession(storage.getToken())
                        ? 'Sign In'
                        : truncatedAddress
                      : 'Connect'}
                  </Button>
                )}
              </ConnectKitButton.Custom>
              {/* <ConnectKitButton /> */}
            </div>
          </div>
        </div>
      </div>

      <div className="flex justify-between bg-black items-center p-6 sticky top-0 z-50 lg:hidden">
        <button
          type="button"
          onClick={() => setOpen(true)}
          className="inline-flex flex-none"
        >
          <Menu />
        </button>
        <div className="inline-flex flex-none">
          <Logo />
        </div>
        {open ? (
          <button
            type="button"
            onClick={() => setOpen(false)}
            className="inline-flex flex-none"
          >
            <Close />
          </button>
        ) : (
          <button type="button" className="inline-flex flex-none">
            <Search />
          </button>
        )}
      </div>
      <div
        className={`${
          open ? 'px-6 w-full' : 'w-0'
        } bg-black flex flex-col gap-12 h-screen py-6 fixed z-10 overflow-x-hidden transition-all duration-500 lg:hidden`}
      >
        <Link
          to="/explore"
          className="text-white flex w-full justify-between items-center"
        >
          <span>Explore</span>
          <span className="inline-flex">
            <AngleRight />
          </span>
        </Link>
        <Link
          to="/profile"
          className="text-white flex w-full justify-between items-center"
        >
          <span>Profile</span>
          <span className="inline-flex">
            <AngleRight />
          </span>
        </Link>
        <Link
          to="/about"
          className="text-white flex w-full justify-between items-center"
        >
          <span>About us</span>
          <span className="inline-flex">
            <AngleRight />
          </span>
        </Link>
        <Link
          to="/faq"
          className="text-white flex w-full justify-between items-center"
        >
          <span>FAQs</span>
          <span className="inline-flex">
            <AngleRight />
          </span>
        </Link>
        <div className="">
          {/* <ConnectButton /> */}
          <Button type="button" onClick={login} variant="primary">
            Connect Wallet
          </Button>
        </div>
      </div>
    </>
  );
};

export default Header;
